import React from 'react';
import './SettingsModal.css';

export default function SettingsModal({
  availableVoices,
  selectedTTSVoice,
  setSelectedTTSVoice,
  isTTSEnabled,
  setIsTTSEnabled,
  saveSettings,
  toggleSettings,
}) {
  return (
    <div className="settings-modal">
      <div className="settings-modal-overlay" onClick={toggleSettings}></div>
      <div className="settings-modal-box">
        <div className="settings-modal-header">
          <h2>Settings</h2>
          <button className="close-btn" onClick={toggleSettings}>✕</button>
        </div>
        <div className="settings-modal-content">
          <div className="settings-left-nav">
            <ul>
              <li className="active-category">Speech</li>
              <li>Notifications</li>
              <li>Personalization</li>
              <li>Data Controls</li>
              <li>Security</li>
            </ul>
          </div>
          <div className="settings-content-area">
            <h3>Voice</h3>
            <div className="settings-row">
              <label htmlFor="ttsVoice">Select TTS Voice:</label>
              <select
                id="ttsVoice"
                value={selectedTTSVoice}
                onChange={(e) => setSelectedTTSVoice(e.target.value)}
              >
                {availableVoices.map((voice, index) => (
                  <option key={index} value={voice.name}>
                    {voice.name} ({voice.lang})
                  </option>
                ))}
              </select>
            </div>
            <div className="settings-row">
              <label htmlFor="ttsEnabled">Auto TTS Replies:</label>
              <input
                id="ttsEnabled"
                type="checkbox"
                checked={isTTSEnabled}
                onChange={(e) => setIsTTSEnabled(e.target.checked)}
              />
            </div>
            <div className="settings-actions">
              <button onClick={saveSettings}>Save Settings</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
